import { IsoTimeOffset } from '../../types/iso-date';

/**
 * Validates an ISO 8601 time offset string.
 *
 * Accepted forms:
 * - 'Z'
 * - '+HH:MM' or '-HH:MM'
 *
 * Bounds (per ISO 8601 and repository convention):
 * - Maximum positive offset: +14:00 (when 14, minutes must be 00)
 * - Maximum negative offset: -12:00 (when 12, minutes must be 00)
 */
export function isIsoTimeOffset(offset: string): offset is IsoTimeOffset {
  if (!offset) return false;
  if (offset === 'Z') return true;

  const m = /^([+-])([01]\d|2[0-3]):([0-5]\d)$/.exec(offset);
  if (!m) return false;

  const sign = m[1];
  const tzHour = Number(m[2]);
  const tzMinute = Number(m[3]);

  if (sign === '+') {
    if (tzHour > 14) return false;
    if (tzHour === 14 && tzMinute !== 0) return false;
  } else {
    if (tzHour > 12) return false;
    if (tzHour === 12 && tzMinute !== 0) return false;
  }

  return true;
}

